import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import {
    Button,
    Card,
    CardBody,
    Container,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from "reactstrap";
import BetterBreadcrumb from 'src/components/Common/BetterBreadCrumb';
import * as url from 'src/helpers/url_helper';
import {
    useGetDataQuery,
} from 'src/rtk/features/common/crudApi';
import { useFcpsPartOneRecordUploadMutation, useMidTermResultUploadMutation } from 'src/rtk/features/midTerm/midTermApi';
import loader from '../../../assets/images/loader.gif';
import PaymentBarChart from './PaymentBarChart';

const AccountantDashboard = (props: any) => {
    const { mainDashboard } = props;
    document.title = 'Accountant Dashboard | BCPS';


    // added modal & file states
    const [isFCPSModalOpen, setFCPSModalOpen] = useState<boolean>(false);
    const [isMidModalOpen, setMidModalOpen] = useState<boolean>(false);
    const [fcpsFile, setFcpsFile] = useState<File | null>(null);
    const [midFile, setMidFile] = useState<File | null>(null);

    const [fcpsPartOneRecordUpload, { isLoading: isFcpsUploadLoading, isSuccess: isFcpsUploadSuccess, isError: isFcpsUploadError }] = useFcpsPartOneRecordUploadMutation();
    const [midTermResultUpload, { isLoading: isMidUploadLoading, isSuccess: isMidUploadSuccess, isError: isMidUploadError }] = useMidTermResultUploadMutation();

    const handleFCPSUpload = (file: File) => {
        if (!file) return;
        const formData = new FormData();
        formData.append('file', file);
        fcpsPartOneRecordUpload(formData);
    };

    const handleMidTermUpload = (file: File) => {
        if (!file) return;
        const formData = new FormData();
        formData.append('file', file);
        midTermResultUpload(formData);
    };

    useEffect(() => {
        if (isFcpsUploadSuccess) {
            toast.success('FCPS Part 1 data uploaded successfully.');
            setFCPSModalOpen(false);
        }
        if (isFcpsUploadError) {
            toast.error('FCPS Part 1 data upload failed.');
        }
        if (isMidUploadSuccess) {
            toast.success('Mid Term data uploaded successfully.');
            setMidModalOpen(false);
        }
        if (isMidUploadError) {
            toast.error('Mid Term data upload failed.');
        }
    }, [isFcpsUploadSuccess, isMidUploadSuccess, isFcpsUploadError, isMidUploadError]);

    var totalPayment: number = 0;
    var numOfPayers: number = 0;

    // const [totalPayment, setTotalPayment] = useState<any>(0);
    const [page, setPage] = useState<any>(1);
    const [limit, setLimit] = useState<any>(10);
    const [search, setSearch] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const generateQueryUrl = () => {
        let queryString = '?';
        if (url.PAYMENT_REPORTS_LIST_ADMIN.includes("?")) {
            queryString = '&';
        }

        // return `${url.PAYMENT_REPORTS_LIST_ADMIN}${queryString}page=${page}&paginate_per_page=${limit}${search}`;
        return `${url.PAYMENT_REPORTS_LIST_ADMIN}${queryString}${search}`;
    };

    const {
        data: dataList,
        isLoading: dataListLoading,
        isSuccess: dataListLoadingSuccess,
        error: dataListLoadingError,
    } = useGetDataQuery(generateQueryUrl());
    const data: any = dataList?.data || [];

    // console.log(data)

    useEffect(() => {
        if (dataListLoadingError) {
            toast.dismiss();
            toast.error('Data Loading error. Please try again later.');
        } else if (dataListLoading || !dataListLoadingSuccess) {
            toast.dismiss();
            // toast.loading('Data Loading...');
        } else {
            toast.dismiss();
            // toast.success('Data Load Successfully');
        }
    }, [dataListLoading, dataListLoadingSuccess, dataListLoadingError]);

    const Counter = ({ end, duration }: any) => {
        const [count, setCount] = useState<number>(0);

        useEffect(() => {
            let start = 0;
            const totalSteps = 60; // Number of updates in the given duration
            const increment = end / totalSteps;

            const stepTime = (duration * 1000) / totalSteps; // Step interval in ms

            const interval = setInterval(() => {
                start += increment;
                if (start >= end) {
                    start = end;
                    clearInterval(interval);
                }
                setCount(Math.floor(start));
            }, stepTime);

            return () => clearInterval(interval);
        }, [end, duration]);

        // Format number with separator
        const formatNumber = (num: number) => num.toLocaleString();

        return (
            <span>
                {formatNumber(count)}
            </span>
        );
    };
    console.log(data)
    return (
        <>
            {
                mainDashboard ?
                    <React.Fragment>
                        {dataListLoading || isFcpsUploadLoading || isMidUploadLoading ? (
                            <div className="overlay">
                                <img src={loader} alt="Loading" height={100} width={300} />
                            </div>
                        ) : null}
                        <BetterBreadcrumb title='Accountant Dashboard' />
                        <Container fluid>
                            <Card className=''>
                                <CardBody className='mx-2'>
                                    <h5 className='block-heading mb-2'>Transaction Status</h5>
                                    <div className="row g-3">
                                        <div className="col-12 col-sm-6 col-lg-4 col-xl">
                                            <div className="dashboard-card h-100 bg-info bg-opacity-10 border border-info text-center p-4 rounded-3">
                                                <div className="text-info mb-2">
                                                    <i className="fas fa-wallet"></i>
                                                </div>
                                                <h6 className="text-muted fw-semibold mb-2">Total Receive</h6>
                                                <h3 className="fw-bold mb-0">
                                                    <Counter
                                                        end={data?.total_received_amount?.map((item: any) => item?.total_amount_sum) ?? 0}
                                                        duration={1}
                                                    />
                                                </h3>
                                                <small className="text-muted">BDT</small>
                                            </div>
                                        </div>

                                        <div className="col-12 col-sm-6 col-lg-4 col-xl">
                                            <div className="dashboard-card h-100 bg-success bg-opacity-10 border border-success text-center p-4 rounded-3">
                                                <div className="text-success mb-2">
                                                    <i className="fas fa-credit-card"></i>
                                                </div>
                                                <h6 className="text-muted fw-semibold mb-2">Online</h6>
                                                <h3 className="fw-bold mb-0">
                                                    <Counter
                                                        end={
                                                            data?.payment_count_by_payment_mode?.find(
                                                                (item: any) => item?.payment_mode?.toLowerCase() === "online"
                                                            )?.total_amount_sum ?? 0
                                                        }
                                                        duration={1}
                                                    />
                                                </h3>
                                                <small className="text-muted">BDT</small>
                                            </div>
                                        </div>

                                        <div className="col-12 col-sm-6 col-lg-4 col-xl">
                                            <div className="dashboard-card h-100 bg-secondary bg-opacity-10 border border-secondary text-center p-4 rounded-3">
                                                <div className="text-secondary mb-2">
                                                    <i className="fas fa-money-bill"></i>
                                                </div>
                                                <h6 className="text-muted fw-semibold mb-2">Offline</h6>
                                                <h3 className="fw-bold mb-0">
                                                    <Counter
                                                        end={
                                                            data?.payment_count_by_payment_mode
                                                                ?.filter((item: any) => item?.payment_mode?.toLowerCase() === "offline")
                                                                ?.reduce((a: number, b: any) => a + parseFloat(b.total_amount_sum), 0) ?? 0
                                                        }
                                                        duration={1}
                                                    />
                                                </h3>
                                                <small className="text-muted">BDT</small>
                                            </div>
                                        </div>

                                        <div className="col-12 col-sm-6 col-lg-4 col-xl">
                                            <div className="dashboard-card h-100 bg-danger bg-opacity-10 border border-primary text-center p-4 rounded-3">
                                                <div className="text-danger mb-2">
                                                    <i className="fas fa-exchange-alt"></i>
                                                </div>
                                                <h6 className="text-muted fw-semibold mb-2">Number of Transaction</h6>
                                                <h3 className="fw-bold mb-0">
                                                    <Counter
                                                        end={data?.number_of_transaction?.map((item: any) => item?.total_count) ?? 0}
                                                        duration={1}
                                                    />
                                                </h3>
                                            </div>
                                        </div>

                                        <div className="col-12 col-sm-6 col-lg-4 col-xl">
                                            <div className="dashboard-card h-100 bg-warning bg-opacity-10 border border-warning text-center p-4 rounded-3">
                                                <div className="text-warning mb-2">
                                                    <i className="fas fa-hourglass-half"></i>
                                                </div>
                                                <h6 className="text-muted fw-semibold mb-2">Verify Pending</h6>
                                                <h3 className="fw-bold mb-0">
                                                    <Counter
                                                        end={
                                                            data?.payment_count_by_verification_status?.find(
                                                                (item: any) => item?.payment_verification_status?.toLowerCase() === "pending"
                                                            )?.total_count ?? 0
                                                        }
                                                        duration={1}
                                                    />
                                                </h3>
                                            </div>
                                        </div>
                                    </div>


                                    <h5 className='block-heading mt-4 mb-2'>Payment Summary</h5>

                                    {/* Date Filter Section */}
                                    {/* <div className="row g-3 mb-4">
                                        <div className="col-12">
                                            <div className="d-flex flex-wrap gap-2">
                                                <Input
                                                    className="form-control form-control-sm"
                                                    style={{ maxWidth: "200px" }}
                                                    name="from_date"
                                                    type="date"
                                                    placeholder="From Date"
                                                    value={fromDate}
                                                    onChange={(e) => {
                                                        setFromDate(e.target.value)
                                                    }}
                                                />
                                                <Input
                                                    className="form-control form-control-sm"
                                                    style={{ maxWidth: "200px" }}
                                                    name="to_date"
                                                    type="date"
                                                    placeholder="To Date"
                                                    value={toDate}
                                                    onChange={(e) => {
                                                        setToDate(e.target.value)
                                                    }}
                                                />
                                                <button
                                                    type="button"
                                                    onClick={(e) => {
                                                        setSearch(`from_date=${fromDate}&to_date=${toDate}`)
                                                    }}
                                                    className="btn btn-sm btn-success px-4">
                                                    <i className="fas fa-search me-1"></i>
                                                    {dataListLoading ? 'Searching...' : 'Search'}
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={(e) => {
                                                        setFromDate("");
                                                        setToDate("");
                                                        setSearch(`from_date=&to_date=`)
                                                    }}
                                                    className="btn btn-sm btn-danger px-4">
                                                    <i className="fas fa-times me-1"></i>
                                                    {dataListLoading ? 'Clearing...' : 'Clear'}
                                                </button>
                                            </div>
                                        </div>
                                    </div> */}

                                    {/* Table Section */}
                                    {/* <div className="table-responsive">
                                        <Table className="table-hover align-middle">
                                            <thead className="bg-light">
                                                <tr className="text-center">
                                                    <th className="text-muted fw-semibold" style={{ width: "70px" }}>SL#</th>
                                                    <th className="text-muted fw-semibold text-start">Payment By</th>
                                                    <th className="text-muted fw-semibold">Number of Payers</th>
                                                    <th className="text-muted fw-semibold" style={{ width: "250px" }}>Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.total_payment_count_by_payment_for?.map(
                                                    (item: any, key: number) => {
                                                        totalPayment += Number(item.total_amount_sum);
                                                        numOfPayers += Number(item.total_count);

                                                        return (
                                                            <tr key={key}>
                                                                <td className="text-center">
                                                                    <span className="badge bg-secondary bg-opacity-10 text-primary fw-semibold px-3 py-2">
                                                                        {key + 1}
                                                                    </span>
                                                                </td>
                                                                <td className="text-start">
                                                                    <h6 className="mb-0 fw-semibold">
                                                                        {item.payment_for}
                                                                    </h6>
                                                                </td>
                                                                <td className="text-center">
                                                                    <span className="badge bg-info bg-opacity-10 text-dark fw-bold px-3 py-2">
                                                                        {item.total_count}
                                                                    </span>
                                                                </td>
                                                                <td className="text-center">
                                                                    <span className="fw-bold text-success">
                                                                        {currency(item.total_amount_sum)}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                )}
                                            </tbody>
                                            <tfoot className="bg-light border-top border-2">
                                                <tr>
                                                    <td colSpan={2} className="text-end py-3">
                                                        <h6 className="mb-0 fw-bold text-muted">Total</h6>
                                                    </td>
                                                    <td className="text-center py-3">
                                                        <h5 className="mb-0 fw-bold text-primary">
                                                            {numOfPayers}
                                                        </h5>
                                                    </td>
                                                    <td className="text-center py-3">
                                                        <h5 className="mb-0 fw-bold text-success">
                                                            {currency(totalPayment)}
                                                        </h5>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </Table>
                                    </div> */}
                                    <PaymentBarChart data={data?.total_payment_count_by_payment_for} />

                                    <div className="row g-3 mt-4">
                                        <div className="col-12 col-md-6">
                                            <div className="upload-card p-3 h-100 d-flex align-items-center justify-content-between border rounded-3">
                                                <div>
                                                    <h6 className="mb-1 fw-semibold">FCPS Part 1 Data Upload</h6>
                                                    <small className="text-muted">Upload FCPS Part 1 trainee data file</small>
                                                </div>
                                                <div>
                                                    <Button color="primary" onClick={() => setFCPSModalOpen(true)}>
                                                        <i className="fas fa-upload me-2"></i> Upload
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <div className="upload-card p-3 h-100 d-flex align-items-center justify-content-between border rounded-3">
                                                <div>
                                                    <h6 className="mb-1 fw-semibold">Midterm Passed Trainee List Upload</h6>
                                                    <small className="text-muted">Upload Midterm passed trainee list</small>
                                                </div>
                                                <div>
                                                    <Button color="primary" onClick={() => setMidModalOpen(true)}>
                                                        <i className="fas fa-upload me-2"></i> Upload
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* FCPS Modal */}
                                    <Modal isOpen={isFCPSModalOpen} toggle={() => setFCPSModalOpen(!isFCPSModalOpen)}>
                                        <ModalHeader toggle={() => setFCPSModalOpen(!isFCPSModalOpen)}>Upload FCPS Part 1 Data</ModalHeader>
                                        <ModalBody>
                                            <div className="file-upload-wrapper text-center">
                                                <input
                                                    id="fcps-file-input"
                                                    type="file"
                                                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => {
                                                        const f = e.target.files?.[0] ?? null;
                                                        setFcpsFile(f);
                                                    }}
                                                />
                                                <Label for="fcps-file-input" className="file-upload-label d-inline-block">
                                                    <div className="upload-inner">
                                                        <i className="fas fa-cloud-upload-alt upload-icon"></i>
                                                        <div className="upload-text">
                                                            {fcpsFile ? fcpsFile.name : "Click to choose a file or drag it here"}
                                                        </div>
                                                    </div>
                                                </Label>
                                            </div>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button color="secondary" onClick={() => { setFCPSModalOpen(false); setFcpsFile(null); }}>Cancel</Button>
                                            <Button color="primary" onClick={() => {
                                                if (!fcpsFile) {
                                                    toast.error('Please select a file to upload.');
                                                    return;
                                                }
                                                // Placeholder: implement actual upload logic
                                                handleFCPSUpload(fcpsFile);

                                            }}>Upload</Button>
                                        </ModalFooter>
                                    </Modal>

                                    {/* Midterm Modal */}
                                    <Modal isOpen={isMidModalOpen} toggle={() => setMidModalOpen(!isMidModalOpen)}>
                                        <ModalHeader toggle={() => setMidModalOpen(!isMidModalOpen)}>Upload Midterm Passed Trainee List</ModalHeader>
                                        <ModalBody>
                                            <div className="file-upload-wrapper text-center">
                                                <input
                                                    id="mid-file-input"
                                                    type="file"
                                                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => {
                                                        const f = e.target.files?.[0] ?? null;
                                                        setMidFile(f);
                                                    }}
                                                />
                                                <Label for="mid-file-input" className="file-upload-label d-inline-block">
                                                    <div className="upload-inner">
                                                        <i className="fas fa-cloud-upload-alt upload-icon"></i>
                                                        <div className="upload-text">
                                                            {midFile ? midFile.name : "Click to choose a file or drag it here"}
                                                        </div>
                                                    </div>
                                                </Label>
                                            </div>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button color="secondary" onClick={() => { setMidModalOpen(false); setMidFile(null); }}>Cancel</Button>
                                            <Button color="primary" onClick={() => {
                                                if (!midFile) {
                                                    toast.error('Please select a file to upload.');
                                                    return;
                                                }
                                                // Placeholder: implement actual upload logic
                                                handleMidTermUpload(midFile);
                                            }}>Upload</Button>
                                        </ModalFooter>
                                    </Modal>
                                </CardBody>
                            </Card>
                        </Container>
                    </React.Fragment>
                    :
                    <div className='page-content'>
                        {dataListLoading ? (
                            <div className="overlay">
                                <img src={loader} alt="Loading" height={100} width={300} />
                            </div>
                        ) : null}
                        <React.Fragment>
                            <BetterBreadcrumb title='Accountant Dashboard' />
                            <Container fluid>
                                <Card className=''>
                                    <CardBody className='mx-2'>
                                        <h5 className='block-heading mb-4'>Transaction Status</h5>
                                        <div className="row g-3">
                                            <div className="col-12 col-sm-6 col-lg-4 col-xl">
                                                <div className="dashboard-card h-100 bg-info bg-opacity-10 border border-info text-center p-4 rounded-3">
                                                    <div className="text-info mb-2">
                                                        <i className="fas fa-wallet"></i>
                                                    </div>
                                                    <h6 className="text-muted fw-semibold mb-2">Total Receive</h6>
                                                    <h3 className="fw-bold mb-0">
                                                        <Counter
                                                            end={data?.total_received_amount?.map((item: any) => item?.total_amount_sum) ?? 0}
                                                            duration={1}
                                                        />
                                                    </h3>
                                                    <small className="text-muted">BDT</small>
                                                </div>
                                            </div>

                                            <div className="col-12 col-sm-6 col-lg-4 col-xl">
                                                <div className="dashboard-card h-100 bg-success bg-opacity-10 border border-success text-center p-4 rounded-3">
                                                    <div className="text-success mb-2">
                                                        <i className="fas fa-credit-card"></i>
                                                    </div>
                                                    <h6 className="text-muted fw-semibold mb-2">Online</h6>
                                                    <h3 className="fw-bold mb-0">
                                                        <Counter
                                                            end={
                                                                data?.payment_count_by_payment_mode?.find(
                                                                    (item: any) => item?.payment_mode?.toLowerCase() === "online"
                                                                )?.total_amount_sum ?? 0
                                                            }
                                                            duration={1}
                                                        />
                                                    </h3>
                                                    <small className="text-muted">BDT</small>
                                                </div>
                                            </div>

                                            <div className="col-12 col-sm-6 col-lg-4 col-xl">
                                                <div className="dashboard-card h-100 bg-secondary bg-opacity-10 border border-secondary text-center p-4 rounded-3">
                                                    <div className="text-secondary mb-2">
                                                        <i className="fas fa-money-bill"></i>
                                                    </div>
                                                    <h6 className="text-muted fw-semibold mb-2">Offline</h6>
                                                    <h3 className="fw-bold mb-0">
                                                        <Counter
                                                            end={
                                                                data?.payment_count_by_payment_mode
                                                                    ?.filter((item: any) => item?.payment_mode?.toLowerCase() === "offline")
                                                                    ?.reduce((a: number, b: any) => a + parseFloat(b.total_amount_sum), 0) ?? 0
                                                            }
                                                            duration={1}
                                                        />
                                                    </h3>
                                                    <small className="text-muted">BDT</small>
                                                </div>
                                            </div>

                                            <div className="col-12 col-sm-6 col-lg-4 col-xl">
                                                <div className="dashboard-card h-100 bg-danger bg-opacity-10 border border-primary text-center p-4 rounded-3">
                                                    <div className="text-danger mb-2">
                                                        <i className="fas fa-exchange-alt"></i>
                                                    </div>
                                                    <h6 className="text-muted fw-semibold mb-2">Number of Transaction</h6>
                                                    <h3 className="fw-bold mb-0">
                                                        <Counter
                                                            end={data?.number_of_transaction?.map((item: any) => item?.total_count) ?? 0}
                                                            duration={1}
                                                        />
                                                    </h3>
                                                </div>
                                            </div>

                                            <div className="col-12 col-sm-6 col-lg-4 col-xl">
                                                <div className="dashboard-card h-100 bg-warning bg-opacity-10 border border-warning text-center p-4 rounded-3">
                                                    <div className="text-warning mb-2">
                                                        <i className="fas fa-hourglass-half"></i>
                                                    </div>
                                                    <h6 className="text-muted fw-semibold mb-2">Verify Pending</h6>
                                                    <h3 className="fw-bold mb-0">
                                                        <Counter
                                                            end={
                                                                data?.payment_count_by_verification_status?.find(
                                                                    (item: any) => item?.payment_verification_status?.toLowerCase() === "pending"
                                                                )?.total_count ?? 0
                                                            }
                                                            duration={1}
                                                        />
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>


                                        <h5 className='block-heading my-4'>Payment Summary</h5>

                                        {/* Date Filter Section */}
                                        {/* <div className="row g-3 mb-4">
                                        <div className="col-12">
                                            <div className="d-flex flex-wrap gap-2">
                                                <Input
                                                    className="form-control form-control-sm"
                                                    style={{ maxWidth: "200px" }}
                                                    name="from_date"
                                                    type="date"
                                                    placeholder="From Date"
                                                    value={fromDate}
                                                    onChange={(e) => {
                                                        setFromDate(e.target.value)
                                                    }}
                                                />
                                                <Input
                                                    className="form-control form-control-sm"
                                                    style={{ maxWidth: "200px" }}
                                                    name="to_date"
                                                    type="date"
                                                    placeholder="To Date"
                                                    value={toDate}
                                                    onChange={(e) => {
                                                        setToDate(e.target.value)
                                                    }}
                                                />
                                                <button
                                                    type="button"
                                                    onClick={(e) => {
                                                        setSearch(`from_date=${fromDate}&to_date=${toDate}`)
                                                    }}
                                                    className="btn btn-sm btn-success px-4">
                                                    <i className="fas fa-search me-1"></i>
                                                    {dataListLoading ? 'Searching...' : 'Search'}
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={(e) => {
                                                        setFromDate("");
                                                        setToDate("");
                                                        setSearch(`from_date=&to_date=`)
                                                    }}
                                                    className="btn btn-sm btn-danger px-4">
                                                    <i className="fas fa-times me-1"></i>
                                                    {dataListLoading ? 'Clearing...' : 'Clear'}
                                                </button>
                                            </div>
                                        </div>
                                    </div> */}

                                        {/* Table Section */}
                                        {/* <div className="table-responsive">
                                        <Table className="table-hover align-middle">
                                            <thead className="bg-light">
                                                <tr className="text-center">
                                                    <th className="text-muted fw-semibold" style={{ width: "70px" }}>SL#</th>
                                                    <th className="text-muted fw-semibold text-start">Payment By</th>
                                                    <th className="text-muted fw-semibold">Number of Payers</th>
                                                    <th className="text-muted fw-semibold" style={{ width: "250px" }}>Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.total_payment_count_by_payment_for?.map(
                                                    (item: any, key: number) => {
                                                        totalPayment += Number(item.total_amount_sum);
                                                        numOfPayers += Number(item.total_count);

                                                        return (
                                                            <tr key={key}>
                                                                <td className="text-center">
                                                                    <span className="badge bg-secondary bg-opacity-10 text-primary fw-semibold px-3 py-2">
                                                                        {key + 1}
                                                                    </span>
                                                                </td>
                                                                <td className="text-start">
                                                                    <h6 className="mb-0 fw-semibold">
                                                                        {item.payment_for}
                                                                    </h6>
                                                                </td>
                                                                <td className="text-center">
                                                                    <span className="badge bg-info bg-opacity-10 text-dark fw-bold px-3 py-2">
                                                                        {item.total_count}
                                                                    </span>
                                                                </td>
                                                                <td className="text-center">
                                                                    <span className="fw-bold text-success">
                                                                        {currency(item.total_amount_sum)}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                )}
                                            </tbody>
                                            <tfoot className="bg-light border-top border-2">
                                                <tr>
                                                    <td colSpan={2} className="text-end py-3">
                                                        <h6 className="mb-0 fw-bold text-muted">Total</h6>
                                                    </td>
                                                    <td className="text-center py-3">
                                                        <h5 className="mb-0 fw-bold text-primary">
                                                            {numOfPayers}
                                                        </h5>
                                                    </td>
                                                    <td className="text-center py-3">
                                                        <h5 className="mb-0 fw-bold text-success">
                                                            {currency(totalPayment)}
                                                        </h5>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </Table>
                                    </div> */}
                                        <PaymentBarChart data={data?.total_payment_count_by_payment_for} />

                                        <div className="row g-3 mt-4">
                                            <div className="col-12 col-md-6">
                                                <div className="upload-card p-3 h-100 d-flex align-items-center justify-content-between border rounded-3">
                                                    <div>
                                                        <h6 className="mb-1 fw-semibold">FCPS Part 1 Data Upload</h6>
                                                        <small className="text-muted">Upload FCPS Part 1 trainee data file</small>
                                                    </div>
                                                    <div>
                                                        <Button color="primary" onClick={() => setFCPSModalOpen(true)}>
                                                            <i className="fas fa-upload me-2"></i> Upload
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-12 col-md-6">
                                                <div className="upload-card p-3 h-100 d-flex align-items-center justify-content-between border rounded-3">
                                                    <div>
                                                        <h6 className="mb-1 fw-semibold">Midterm Passed Trainee List Upload</h6>
                                                        <small className="text-muted">Upload Midterm passed trainee list</small>
                                                    </div>
                                                    <div>
                                                        <Button color="primary" onClick={() => setMidModalOpen(true)}>
                                                            <i className="fas fa-upload me-2"></i> Upload
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* FCPS Modal */}
                                        <Modal isOpen={isFCPSModalOpen} toggle={() => setFCPSModalOpen(!isFCPSModalOpen)}>
                                            <ModalHeader toggle={() => setFCPSModalOpen(!isFCPSModalOpen)}>Upload FCPS Part 1 Data</ModalHeader>
                                            <ModalBody>
                                                <div className="file-upload-wrapper text-center">
                                                    <input
                                                        id="fcps-file-input"
                                                        type="file"
                                                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                        style={{ display: 'none' }}
                                                        onChange={(e) => {
                                                            const f = e.target.files?.[0] ?? null;
                                                            setFcpsFile(f);
                                                        }}
                                                    />
                                                    <Label for="fcps-file-input" className="file-upload-label d-inline-block">
                                                        <div className="upload-inner">
                                                            <i className="fas fa-cloud-upload-alt upload-icon"></i>
                                                            <div className="upload-text">
                                                                {fcpsFile ? fcpsFile.name : "Click to choose a file or drag it here"}
                                                            </div>
                                                        </div>
                                                    </Label>
                                                </div>
                                            </ModalBody>
                                            <ModalFooter>
                                                <Button color="secondary" onClick={() => { setFCPSModalOpen(false); setFcpsFile(null); }}>Cancel</Button>
                                                <Button color="primary" onClick={() => {
                                                    if (!fcpsFile) {
                                                        toast.error('Please select a file to upload.');
                                                        return;
                                                    }
                                                    // Placeholder: implement actual upload logic
                                                    handleFCPSUpload(fcpsFile);

                                                }}>Upload</Button>
                                            </ModalFooter>
                                        </Modal>

                                        {/* Midterm Modal */}
                                        <Modal isOpen={isMidModalOpen} toggle={() => setMidModalOpen(!isMidModalOpen)}>
                                            <ModalHeader toggle={() => setMidModalOpen(!isMidModalOpen)}>Upload Midterm Passed Trainee List</ModalHeader>
                                            <ModalBody>
                                                <div className="file-upload-wrapper text-center">
                                                    <input
                                                        id="mid-file-input"
                                                        type="file"
                                                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                        style={{ display: 'none' }}
                                                        onChange={(e) => {
                                                            const f = e.target.files?.[0] ?? null;
                                                            setMidFile(f);
                                                        }}
                                                    />
                                                    <Label for="mid-file-input" className="file-upload-label d-inline-block">
                                                        <div className="upload-inner">
                                                            <i className="fas fa-cloud-upload-alt upload-icon"></i>
                                                            <div className="upload-text">
                                                                {midFile ? midFile.name : "Click to choose a file or drag it here"}
                                                            </div>
                                                        </div>
                                                    </Label>
                                                </div>
                                            </ModalBody>
                                            <ModalFooter>
                                                <Button color="secondary" onClick={() => { setMidModalOpen(false); setMidFile(null); }}>Cancel</Button>
                                                <Button color="primary" onClick={() => {
                                                    if (!midFile) {
                                                        toast.error('Please select a file to upload.');
                                                        return;
                                                    }
                                                    // Placeholder: implement actual upload logic
                                                    handleMidTermUpload(midFile);
                                                }}>Upload</Button>
                                            </ModalFooter>
                                        </Modal>
                                    </CardBody>
                                </Card>
                            </Container>
                        </React.Fragment>
                    </div>
            }
        </>
    );
};

export default AccountantDashboard;
